import { Group, Rect, Text } from 'react-konva';
import { STAGE_H } from './constants';

export type TooltipState = {
    x: number;
    y: number;
    name: string;
    diDiff: number;
    deviation: number;
};

export type TooltipProps = {
    state: TooltipState;
    xOrigin: number;
};

export function Tooltip({ state, xOrigin }: TooltipProps) {
    const { x, y, name, deviation, diDiff } = state;

    const PAD = 10;
    const GAP = 6;
    const cardW = 155;
    const nameH = 20;
    const metricsH = 40;
    const cardH = PAD + nameH + GAP + metricsH + PAD;

    // Adjust the tooltip position as needed so it doesn't
    // overflow at the bottom of the chart area
    const overflowY = y + cardH - STAGE_H;
    const adjustedY = y - 12 - (overflowY > 0 ? overflowY : 0);

    // Show the tooltip on the opposite side once past the vertical axis
    const overflowX = x - xOrigin;
    const adjustedX = overflowX > 0 ? x - 16 - cardW : x + 16;

    const metricsText = [
        `偏差値: ${deviation.toFixed(1)}`,
        `DI変化: ${diDiff >= 0 ? '+' : ''}${diDiff.toFixed(1)}`,
    ].join('\n');

    return (
        <Group x={adjustedX} y={adjustedY}>
            <Rect
                width={cardW}
                height={cardH}
                fill="white"
                cornerRadius={6}
                shadowColor="black"
                shadowBlur={6}
                shadowOpacity={0.12}
                shadowOffsetY={2}
            />
            <Text x={PAD} y={PAD} width={cardW - PAD * 2} text={name} fontSize={14} fontStyle="bold" fill="#333" />
            <Text
                x={PAD}
                y={PAD + nameH + GAP}
                width={cardW - PAD * 2}
                text={metricsText}
                fontSize={12}
                fill="#555"
                lineHeight={1.6}
            />
        </Group>
    );
}
